"use client";
import Link from "next/link";
import { makeLocalizedHref } from "@/lib/localizedRoutes/routeHelpers";
import { ListingTypeEnum } from "@/types/types";
import { useLocale } from "next-intl";
import { toast } from "react-toastify";
import { useMyListingsStore } from "../../../useMyListingsStore";
import styles from "./listing-settings-modal.module.css";

interface Props {
  listingData: any;
  sessionId: string | null;
  closeCallbackAction: () => void;
}

export default function NoSubscriptionSection({
  listingData,
  sessionId,
  closeCallbackAction,
}: Props) {
  const locale = useLocale();
  const { changeListingTypeNoPlan } = useMyListingsStore();

  async function handleChange(e: React.ChangeEvent<HTMLSelectElement>) {
    const newType = e.target.value as ListingTypeEnum;
    await changeListingTypeNoPlan(newType, listingData.listing_id, sessionId);
  }

  return (
    <>
      <label className={styles.selectLabel}>Select Plan</label>
      <select
        className={styles.select}
        value={listingData.listing_type}
        onChange={handleChange}
      >
        <option value="essential">Essential - 4.5 EUR</option>
        <option value="plus">Plus - 9.5 EUR</option>
        <option value="prime">Prime - 19.5 EUR</option>
        <option value="spotlight">Spotlight - 39.5 EUR</option>
      </select>

      <div className={styles.statusWrapper}>
        <p className={styles.statusInfo}>
          Ready to activate your plan? You’ll be guided through a quick payment
          setup before your listing goes live.
        </p>
        <Link
          type="button"
          className={styles.activatePlanBtn}
          href={makeLocalizedHref(locale, "new-listing", [
            "publish",
            listingData.listing_id,
          ])}
          onClick={() => {
            closeCallbackAction();
          }}
        >
          Activate Plan
        </Link>
      </div>
    </>
  );
}
